import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import SelectDropdown from "../../components/SelectDropdown";
import { Card, Col, Form, Row } from "react-bootstrap";
import useAddNewMappingViewController from "../../viewControllers/MappinManagementControllers/AddNewMappingViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";

const AddNewMapping = () => {
    const {
      goBack,
      skuCategory,
      showSku,
      setShowSku,
      inventoryList,
      gwpskulist,
      fetchInventoryData,
      handleSubmit,
      values,
      setFieldValue,
      touched,
      errors,
      loading,
      dropdownLoading,
    } = useAddNewMappingViewController();
    
    const text = {
      pageHeading: i18n.t('mappingManagement.addNewMapping.pageHeading'),
      backBtn: i18n.t('mappingManagement.addNewMapping.backBtn'),
      saveBtn: i18n.t('mappingManagement.addNewMapping.saveBtn'),
      selectGoodStockSKU: i18n.t('mappingManagement.addNewMapping.selectGoodStockSKU'),
      selectGWP: i18n.t('mappingManagement.addNewMapping.selectGWP'),
      selectGoodStock: i18n.t('mappingManagement.addNewMapping.selectGoodStock'),
    }
  return (
    <>
      {loading ? <Loader /> : (
      <div className="container-fluid mt-5">
        <div className="smb-4">
          <div className="card-header py-3">
          <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
            <h6 className="m-0 font-weight-bold txt-primary">
              
            </h6>
          </div>
          <Card style={{ width: "100%", height: "500px" }}>
            <Form onSubmit={handleSubmit} className="mt-4 mb-4 px-4">
              <Row className="mt-5">
                <div className="d-flex justify-content-center">
                  <div className=" mt-3 px-4">
                    <p className="mb-2">
                      {text.selectGoodStock}
                      <span style={{ color: "red" }}>*</span>{" "}
                    </p>
                  </div>
                  <div style={{ width: "30%" }}>
                    <SelectDropdown
                      isSearchable={true}
                      placeholder="Select Category"
                      data={skuCategory}
                      value={values?.category}
                      onChange={(e) => {
                        setFieldValue("category", e?.value);
                        setShowSku(true);
                        fetchInventoryData(e?.value);
                      }}
                      errors={touched?.category && errors?.category}
                      isLoading={dropdownLoading}
                    />
                  </div>
                </div>
              </Row>

              <Row className="mt-3">
                {showSku ? (
                  <>
                    <Col className="col-lg-6">
                      <Row className="mt-5">
                        <Col className="col-lg-6 mt-3">
                          <p>
                            {text.selectGoodStockSKU}
                            <span style={{ color: "red" }}>*</span>{" "}
                          </p>
                        </Col>
                        <Col className="col-lg-6">
                          <SelectDropdown
                            isSearchable={true}
                            placeholder="Search by SKU-ID or Name"
                            data={inventoryList}
                            value={values?.good_stock_sku_item?.item_sid}
                            onChange={(e) => {
                              setFieldValue(
                                "good_stock_sku_item",
                                JSON.stringify(e?.value)
                              );
                            }}
                            errors={
                              touched?.good_stock_sku_item &&
                              errors?.good_stock_sku_item
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col className="col-lg-6">
                      <Row className="mt-5">
                        <Col className="col-lg-5 mt-3">
                          <p>
                           {text.selectGWP}
                            <span style={{ color: "red" }}>*</span>{" "}
                          </p>
                        </Col>
                        <Col className="col-lg-7">
                          <SelectDropdown
                            isSearchable={true}
                            placeholder="Search by SKU-ID or Name"
                            data={gwpskulist}
                            value={values?.gwp_sku_item?.item_sid}
                            onChange={(e) => {
                              setFieldValue(
                                "gwp_sku_item",
                                JSON.stringify(e?.value)
                              );
                            }}
                            errors={
                              touched?.gwp_sku_item && errors?.gwp_sku_item
                            }
                          />
                        </Col>
                      </Row>
                    </Col>
                  </>
                ) : null}
              </Row>
              <div className="d-flex">
                <>
                  <PrimaryButton
                    type="submit"
                    text={text.saveBtn}
                    className="width-auto save-btn "
                  />
                </>
              </div>
            </Form>
          </Card>
        </div>
      </div>
      )}
    </>
  );
};

export default AddNewMapping;
